import { validEmailPattern } from "../../Helpers";

const SPECIAL = /[!@#$%^&*(),.?":{}|<>]/;

export const validatePasswordStrength = (password = "") =>
  password.length >= 8 &&
  /[a-z]/.test(password) &&
  /[A-Z]/.test(password) &&
  /\d/.test(password) &&
  SPECIAL.test(password);

export const getPasswordFlags = (password = "", confirmPassword = "") => ({
  hasLengthValid: password.length >= 8,
  hasLowerCaseValid: /[a-z]/.test(password),
  hasUpperCaseValid: /[A-Z]/.test(password),
  hasNumberValid: /\d/.test(password),
  hasSpecialCharValid: SPECIAL.test(password),
  isConfirmPassChk: password === confirmPassword,
  isValidPassword: validatePasswordStrength(password),
});

export const NAME_PATTERN = /^[A-Za-z0-9_ ]*$/;
export const PHONE_PATTERN = /^\d{3,}$/;

const isEmpty = (value) =>
  value === "" || value === null || value === undefined;

const vatInvalid = (value) => {
  const num = Number(value);
  return isEmpty(value) || Number.isNaN(num) || num < 0 || num > 100;
};

export const computeCreateFieldErrors = (
  form = {},
  accountsform = {},
  extras = {},
) => {
  const errors = {};
  const userType = form.userType;
  const name = String(form.name ?? "").trim();
  const email = String(form.email ?? "").trim();
  const password = String(form.password ?? "").trim();
  const confirmPassword = String(form.confirmPassword ?? "").trim();
  const phoneStr = String(form.phone ?? "").trim();

  if (isEmpty(userType)) errors.userType = true;
  if (!name) errors.name = true;
  if (!email || !validEmailPattern.test(form.email)) errors.email = true;
  if (!extras.skipPassword) {
    if (!password || !validatePasswordStrength(password)) errors.password = true;
    if (!confirmPassword || password !== confirmPassword) {
      errors.confirmPassword = true;
    }
  }
  if (!PHONE_PATTERN.test(phoneStr)) errors.phone = true;

  if (userType > 2) {
    const accountEmail = String(form.accountEmail ?? "").trim();
    if (!accountEmail || !validEmailPattern.test(form.accountEmail)) {
      errors.accountEmail = true;
    }
    if (!String(form.contractName ?? "").trim()) errors.contractName = true;
    if (!form.status) errors.status = true;
    if (!form.companyId) errors.companyId = true;
    if (!form.contractType) errors.contractType = true;
    if (!form.accountName) errors.accountName = true;
    if (!form.contractNumber) errors.contractNumber = true;
    if (vatInvalid(form.vatPercentage)) errors.vatPercentage = true;

    if (userType === 4 && !form.customerType) errors.customerType = true;
    if (userType === 3) {
      if (!String(form.nameArabic ?? "").trim()) errors.nameArabic = true;
      const markupNum = Number(form.markup);
      if (isEmpty(form.markup) || Number.isNaN(markupNum) || markupNum < 0 || markupNum > 100) {
        errors.markup = true;
      }
      if (!form.amUserId && !extras.managerAccountSelect?.id) errors.amUserId = true;
    }
    if (userType === 5 || userType === 6) {
      if (!String(accountsform.c_taxNumber ?? "").trim()) errors.c_taxNumber = true;
      if (!form.creditPeriod) errors.creditPeriod = true;
    }
  }

  if (form.contractStartDate && form.contractEndDate) {
    if (new Date(form.contractStartDate) > new Date(form.contractEndDate)) {
      errors.contractEndDate = true;
    }
  }
  return errors;
};
